export interface UserResultModel {
	data?: User[];
	totalCount: number;
	summary?: number[];
	groupCount?: number;
}

export class User {
	public UserId: number;
	public Sid: string;
	public PrincipalName: string;
	public UserRoleId: number;
	public UserRoleAlternateKey: string;
	public UserRoleName: string;
	public LastKnownSurname: string;
	public LastKnownMiddleName: string;
	public LastKnownGivenName: string;
	public LastKnownEmailAddress: string;
	public LastKnownGivenNameAndSurname: string;
	public LastKnownGivenNameAndSurnameOrPrincipalName: string;
	public LastKnownFullName: string;
	public LastKnownFullNameOrPrincipalName: string;
	public LastKnownFullNameSortable: string;
	public LastKnownFullNameSortableOrPrincipalName: string;
	public CreatedOn: Date;
	public CreatedByUserId: number;
	public ModifiedOn: Date | string;
	public ModifiedByUserId: number;
	public UserIsActive: boolean;
	public Active: boolean;
}

export class AdUser {
	constructor(
		public onprem_sid: string,
		public upn: string,
		public family_name: string,
		public given_name: string,
		public unique_name: string) { }
}

export interface UserMappingOption {
	ModifiedByUserId?: number;
	ActionType?: number;
}

export class GridSettings {
	public Id?: number;
	public PageName: string;
	public GridName: string;
	public Settings?: GridSetting | string;
	public OwnedByUserId: number;
	public SavedOn?: Date;
}

export class GridState {
	public Id?: number;
	public PageName: string;
	public GridName: string;
	public StateName?: string;
	public State?: string;
	public OwnedByUserId: number;
	public SavedOn?: Date;
}

export class GridSetting {
	autosave = true;
}
